import { map, values } from "lodash";
import { Action } from "shared/models/Action";
import { TaskAttribute } from "shared/models/TaskAttribute";
import { TaskAttributeMulti } from "shared/models/TaskAttributeMulti";
import { AttributeDto } from "tasksBoard/service/api/AttributeDto";
import { DictionaryItemDto } from "tasksBoard/service/api/DictionaryItemDto";
import { resourceLimits } from "worker_threads";

export class TaskAttributeFromResponse {
    constructor(private attributesFromResponse: AttributeDto[], private attributeName: string) {}

    private attributeToTaskAttribute(id: number, attributeValue: DictionaryItemDto): TaskAttribute {
        return {
            id: id,
            action: attributeValue && {
                description: attributeValue.description,
                orderIndex: attributeValue.orderIndex,
            },
        };
    }

    taskAttribute(): TaskAttribute | undefined {
        const attribute = this.attributesFromResponse.filter((x) => x.code === this.attributeName);

        if (!attribute.length) {
            return undefined;
        }

        const attributeValue = attribute[0].customValue.value as DictionaryItemDto;

        return this.attributeToTaskAttribute(attribute[0].id, attributeValue);
    }

    taskAttributeMulti(): TaskAttributeMulti | undefined {
        const attribute = this.attributesFromResponse.filter((x) => x.code === this.attributeName);

        if (!attribute.length) {
            return undefined;
        }

        const attributeValues = attribute[0].customValue.value as DictionaryItemDto[];

        return {
            id: attribute[0].id,
            action: attributeValues.map((x) => {
                return {
                    description: x.description,
                    orderIndex: x.orderIndex,
                };
            }),
        };
    }
}
